import { Grid } from '@mui/material'
import {
  AutomaticListAddingComponent,
  CustomInput,
} from 'src/consumer/components/helperComponents'
import { getFooterFieldsConfig } from '../utils/prescriptionLayoutConfig'

/**
 * Conditional footer fields renderer based on layout type
 * Handles different field combinations for various footer layouts
 */
export default function FooterFieldsRenderer({
  prescriptionTemplate,
  handleChangeFooter,
  disabled,
}) {
  const layout = prescriptionTemplate?.layout
  const footer = prescriptionTemplate?.footer
  const fieldsConfig = getFooterFieldsConfig(layout)

  return (
    <>
      {/* Standard fields (headline, headlineAlt, subtext, subtextAlt) */}
      {fieldsConfig.showStandardFields && (
        <>
          {fieldsConfig.showAltFields && (
            <Grid item xs={12} md={6}>
              <CustomInput
                id="headlineAlt"
                label="Footer Alt Headline"
                value={footer?.headlineAlt}
                onChange={handleChangeFooter}
                disabled={disabled}
              />
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <CustomInput
              id="headline"
              label="Footer Headline"
              value={footer?.headline}
              onChange={handleChangeFooter}
              disabled={disabled}
            />
          </Grid>
          {fieldsConfig.showAltFields && (
            <Grid item xs={12} md={6}>
              <CustomInput
                id="subtextAlt"
                label="Footer Alt Subtext"
                value={footer?.subtextAlt}
                onChange={handleChangeFooter}
                disabled={disabled}
              />
            </Grid>
          )}
        </>
      )}

      {/* Subtext - always shows */}
      {fieldsConfig.showSubtext && (
        <Grid item xs={12} md={6}>
          <CustomInput
            id="subtext"
            label="Footer Subtext"
            value={footer?.subtext}
            onChange={handleChangeFooter}
            disabled={disabled}
          />
        </Grid>
      )}

      {/* Support text fields */}
      {fieldsConfig.showSupportTextAlt && fieldsConfig.showStandardFields && (
        <Grid item xs={12} md={6}>
          <CustomInput
            id="supportTextAlt"
            label="Footer Alt Support Text"
            value={footer?.supportTextAlt}
            onChange={handleChangeFooter}
            disabled={disabled}
          />
        </Grid>
      )}
      {fieldsConfig.showSupportText && fieldsConfig.showStandardFields && (
        <Grid item xs={12} md={6}>
          <CustomInput
            id="supportText"
            value={footer?.supportText}
            onChange={handleChangeFooter}
            label="Support Text"
            disabled={disabled}
          />
        </Grid>
      )}

      {/* List pointer fields */}
      {fieldsConfig.showListPointerFields && (
        <>
          <Grid item xs={12}>
            <AutomaticListAddingComponent
              id="footerListItems"
              label="Footer List Items"
              value={footer?.footerListItems}
              onChange={handleChangeFooter}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              id="subtext"
              label="Footer Subtext"
              value={footer?.subtext}
              onChange={handleChangeFooter}
              disabled={disabled}
            />
          </Grid>
        </>
      )}

      {/* Disclaimer field */}
      {fieldsConfig.showDisclaimerField && (
        <Grid item xs={12}>
          <CustomInput
            id="disclaimerText"
            label="Disclaimer Text"
            value={footer?.disclaimerText}
            onChange={handleChangeFooter}
            disabled={disabled}
          />
        </Grid>
      )}
    </>
  )
}
